import { NoSyncCollection } from 'zoomforth_zfutils/backbone_no_sync_model_mixin.js';

(function() {

  zfrespond.models.Response = Backbone.Model.extend({

    urlRoot: '/v2/respond/responses',

    defaults: {
      asset_caption: null,
      text_response: null
    },

    initialize: function(attrs, options) {
      var opts = options || {};
      this.assetPrecursor = opts.assetPrecursor;
    }

  });
  

  zfrespond.models.Responses = Backbone.Collection.extend(_.extend({},
    NoSyncCollection, {
      
    model: zfrespond.models.Response

  }));


}());